export function browseChrome(path) {
  if (/^\/account-deletion\/?$/.test(path)) return {};
  if (/^\/admin(?:\/|$)/.test(path)) return {};
  if (path === '/search' || path === '/search/') return { search: 'home' };
  const search = /^\/search\/(summary|reviews|artists|lists|mixes)\/?$/.exec(path);
  if (search) return { search: search[1] };
  if (/^\/lists\/(?:create|new|[^/]+\/edit)\/?$/.test(path)) return { detail: 'playlist' };
  const browse = { '/albums': 'albums', '/reviews': 'reviews', '/lists': 'playlists' }[path];
  if (browse) return { browse };
  if (/^\/reviews\/[^/]+(?:\/[^/]+)?\/related-albums\/?$/.test(path)) return { detail: 'album' };
  if (/^\/artists\/[^/]+(?:\/[^/]+){0,2}\/?$/.test(path)) return { detail: 'artist' };
  if (
    /^\/lists\/[^/]+(?:\/comment\/\d+)?\/?$/.test(path) &&
    !['/lists/create', '/lists/new'].includes(path)
  )
    return { detail: 'playlist' };
  return null;
}
